import React from 'react';
import { Menu as HLMenu } from '@headlessui/react';
import useMenuContext from './useMenuContext';
import { BaseButtonProps } from '@teetsh/app/src/components/Buttons/BaseButtonProps';
import { buttonRootStyle } from '@teetsh/app/src/components/Buttons/Button';
import styled from '@emotion/styled';
import clsx from 'clsx';
import { ButtonContent } from '@teetsh/app/src/components/Buttons/ButtonContent';

interface Props {
  buttonRef?: any;
}

const MenuButtonStyled: any = styled(
  ({ buttonRef, className, children, disabled, ...rest }) => (
    <HLMenu.Button
      ref={buttonRef}
      className={clsx('tsh-button', className)}
      aria-label={rest['aria-label']}
      data-testid={rest['data-testid']}
      disabled={disabled}
    >
      <ButtonContent {...rest} disabled={disabled}>
        {children}
      </ButtonContent>
    </HLMenu.Button>
  ),
)((p: BaseButtonProps) => [buttonRootStyle(p)]);

export function MenuButton(props: Props & BaseButtonProps) {
  const { refs } = useMenuContext();
  return (
    <div ref={refs.setReference}>
      <MenuButtonStyled {...props} hasChildren={!!props.children} />
    </div>
  );
}
